import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import { Building2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// OP2-E: Betreiber-Studio-Switcher — nur sichtbar bei >1 autorisiertem Studio.
// Autorisierungswahrheit kommt ausschliesslich vom Server (accessible-studios).
export const OperatorStudioSwitcher = () => {
  const { user, switchStudio, isSuperAdmin } = useAuth();
  const [studios, setStudios] = useState([]);

  useEffect(() => {
    if (!user || isSuperAdmin) return;
    axios.get(`${API}/auth/accessible-studios`)
      .then((res) => setStudios(res.data || []))
      .catch(() => setStudios([]));
  }, [user, isSuperAdmin]);

  if (isSuperAdmin || studios.length < 2) return null;
  const current = studios.find((s) => s.is_current);

  return (
    <div
      data-testid="operator-studio-switcher"
      className="flex items-center gap-2 px-3 py-1.5 rounded-md bg-zinc-800/60 border border-zinc-700"
    >
      <Building2 className="w-4 h-4 text-amber-400" />
      <select
        data-testid="operator-studio-select"
        className="bg-transparent text-sm text-zinc-100 outline-none cursor-pointer"
        value={current?.id || ""}
        onChange={(e) => {
          if (e.target.value && e.target.value !== current?.id) {
            switchStudio(e.target.value);
          }
        }}
      >
        {studios.map((s) => (
          <option key={s.id} value={s.id} className="bg-zinc-900">
            {s.name}{s.is_home ? " (Home)" : ""}
          </option>
        ))}
      </select>
    </div>
  );
};
